<template>
<div class="">
      <div class="title">
        <el-button type="primary" @click="showAdd" size="small">添加角色</el-button>
        <div class="container">
          <el-table
            :data="tableData" v-loading="loadingS" 
            style="width: 100%;margin-top:20px;"
            border 
            :cell-style="rowClassBody" 
            :header-cell-style="{background:'#F5F7FF',color:'#636365',fontSize:'14px'}"
            stripe>
            <el-table-column label="序号" prop="" width="150" align="center">
              <template slot-scope="scope">
                <span v-text="getIndex(scope.$index)"> </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="rolename"
              label="角色"
              width="240"
              align="center">
              <template slot-scope="scope">
                <div v-text="scope.row.role.rolename" style="display: inline-block;vertical-align: middle;"></div>
              </template>
            </el-table-column>
            <el-table-column
              label="用户"
              width="250"
              align="center">
              <template slot-scope="scope">
                <div v-for="user in scope.row.users">
                  <div v-text="user.loginName" style="display: inline-block;vertical-align: middle;"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="菜单"
              width="330"
              align="center">
              <template slot-scope="scope">
                  <p v-for="menu in scope.row.menus">
                    <span>{{menu.name}}</span>
                    <!-- <el-tag v-for="perm in menu.permissions" :key="perm.permissionName" v-text="perm.permissionName"
                      style="margin-right: 3px;"
                      type="primary">
                    </el-tag> -->
                  </p>
              </template>
            </el-table-column>
            <el-table-column
              label="权限"
              width="350"
              align="center">
              <template slot-scope="scope">
                    <!-- <el-tag v-for="perm in menu.permissions" :key="perm.permissionName" v-text="perm.permissionName"
                      style="margin-right: 3px;"
                      type="primary">
                    </el-tag> -->
                    <el-button type="success" icon="edit" disabled
                      v-if="scope.row.role.insertdata == 1">新增
                    </el-button>
                    <el-button disabled v-else>新增
                    </el-button>
                    <el-button type="success" icon="edit" disabled
                      v-if="scope.row.role.modifydata == 1">修改
                    </el-button>
                    <el-button disabled v-else>修改
                    </el-button>
                    <el-button type="success" icon="edit" disabled
                      v-if="scope.row.role.deletedata == 1">删除
                    </el-button>
                    <el-button disabled v-else>删除
                    </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center"
            width="320">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                <el-button
                  type="danger"
                  size="small"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block mb30 tac">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.totalSize">
          </el-pagination>
        </div>
      </div>
      <el-dialog
        :title="textMap[dialogStatus]"
        :visible.sync="dialogVisible"
        width="30%">
        <el-form label-width="80px" :model="form">
          <el-form-item label="角色名称">
            <el-input v-model="form.rolename"></el-input>
          </el-form-item>
          <el-form-item label="菜单">
            <div v-for=" (menu,_index) in allMenus" :key="menu.name">
              <span style="width: 100px;display: inline-block;">
                <el-button size="mini"
                    style="width:100px;"
                    :type="(form.permissions.indexOf(menu.id) == -1)?'delete':'success'"
                    @click="check(_index)">{{menu.name}}
                </el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item label="权限">
            <el-button size="mini"
                style="width:100px;"
                :type="(form.insertdata == 1)?'success':'delete'"
                @click="roleInsert">新增
            </el-button>
            <el-button size="mini"
                style="width:100px;"
                :type="(form.modifydata == 1)?'success':'delete'"
                @click="roleUpdate">修改
            </el-button>
            <el-button size="mini"
                style="width:100px;"
                :type="(form.deletedata == 1)?'success':'delete'"
                @click="roleDelete">删除
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button v-if="dialogStatus=='add'"  type="primary" @click="addRole">添加</el-button>
          <el-button type="primary" v-else @click="updateRole">修改</el-button>
        </span>
      </el-dialog>
  </div>
</template>


<script>
import $ from "jquery";
  export default {
    data() {
        return {
          tableData: [],
          dialogVisible:false,
          form:{
            permissions:[],
            rolename:'',
            insertdata:'',
            deletedata:'',
            modifydata:''
          },
          dialogStatus:'add',
          allMenus:[],
          textMap:{
            add:'添加',
            update:'修改',
          },
          page:{
            pageSize:10,
            totalSize:0,
            pageNum:1
          },
          loadingS:false,
        }
    },
    methods: {
      //获取所有角色权限列表
      getAllRoleList(){
        this.loadingS = true;
        let params = {
            pageNum:this.page.pageNum,
            pageSize:this.page.pageSize,
        };
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
              method:'post',
              url:window.API_HOST+'/role/selectAllRoleList',
              data: params,
        }).then((res)=>{
          this.loadingS = false;
          this.tableData = res.data.data;
          this.page = res.data.page;
        })
      },
      //获取菜单权限列表
      getAllMenu(){
          this.axios({
                method:'get',
                url:window.API_HOST+'/role/selectAllMenu',
          }).then((res)=>{
            this.allMenus = res.data.data;
        })
      },
      //点击菜单，保存菜单id
      check(index){
        if(this.form.permissions.indexOf(this.allMenus[index].id) == -1)
        {
          // this.form.permissions += this.allMenus[index].id +',';
          this.form.permissions.push(this.allMenus[index].id);
          console.log(this.form.permissions);
        }
        else{
          // var str = this.allMenus[index].id;
          // this.form.permissions = this.form.permissions.replace(str+',', '');
          for(let i =0;i<this.form.permissions.length;i++){
            if(this.form.permissions[i] == this.allMenus[index].id){
              this.form.permissions.splice(i,1);
            }
          }
          console.log(this.form.permissions);
        }
      },
      //点击权限，保存 新增
      roleInsert(){
        if(this.form.insertdata == 1){
          this.form.insertdata = null;
        }
        else{
          this.form.insertdata = 1;
        }
      },
      //点击权限，保存 修改
      roleUpdate(){
        if(this.form.modifydata == 1){
          this.form.modifydata = null;
        }
        else{
          this.form.modifydata = 1;
        }
      },
      //点击权限，保存 删除权限
      roleDelete(){
        if(this.form.deletedata == 1){
          this.form.deletedata = null;
        }
        else{
          this.form.deletedata = 1;
        }
      },
      //显示新增对话框
      showAdd(){
        this.dialogVisible = true;
        this.dialogStatus = 'add';
        this.form.rolename = '';
        this.form.permissions = [];
        this.form.insertdata = '';
        this.form.modifydata = '';
        this.form.deletedata = '';
      },
      //添加角色
      addRole(){
        let params = {
              rolename:this.form.rolename,
              // permissions:this.form.permissions.substring(0, this.form.permissions.lastIndexOf(',')),
              permissions:this.form.permissions.join(','),
              insertdata:this.form.insertdata,
              modifydata: this.form.modifydata,
              deletedata:this.form.deletedata,
          }
          // params = this.$qs.stringify(params,{ indices: false });
          this.axios({
                method:'post',
                url:window.API_HOST+'/role/addRole',
                params:params
          }).then((res)=>{
              console.log(res.data);
              if(res.data.status == '200'){
                  this.$message({
                    message: res.data.data,
                    type: 'success'
                });
              }
              this.getAllRoleList();
              this.dialogVisible = false;
          })
      },
      //显示修改对话框
      handleEdit($index){
        this.dialogVisible = true;
        this.dialogStatus = 'update';
        let role = this.tableData[$index];
        this.form.roleid = role.role.roleid;
        this.form.rolename = role.role.rolename;
        this.form.permissions = [];
        // for(var i =0;i<role.menus.length;i++){
        //   this.form.permissions += role.menus[i].id + ',';
        // };
        for(let i=0;i<role.menus.length;i++){
          this.form.permissions.push(role.menus[i].id);
        }
        this.form.insertdata = role.role.insertdata;
        this.form.modifydata = role.role.modifydata;
        this.form.deletedata = role.role.deletedata;
      },
      //修改角色信息
      updateRole(){
        let params = {
              roleid:this.form.roleid,
              rolename:this.form.rolename,
              // permissions:this.form.permissions.substring(0,this.form.permissions.lastIndexOf(',')),
              permissions:this.form.permissions.join(','),
              insertdata:this.form.insertdata,
              modifydata: this.form.modifydata,
              deletedata:this.form.deletedata,
          }
          console.log(typeof params.permissions)
          // params = this.$qs.stringify(params,{ indices: false });
          this.axios({
                method:'post',
                url:window.API_HOST+'/role/modifyRole',
                params:params
          }).then((res)=>{
              console.log(res.data);
              if(res.data.status == '200'){
                  this.$message({
                    message: res.data.data,
                    type: 'success'
                });
              }
              this.getAllRoleList();
              this.dialogVisible = false;
          })
      },
      //删除角色
      handleDelete($index){
        this.$confirm('将删除该角色, 是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let role = this.tableData[$index];
          console.log(role.role.rolename)
          let params = {
                roleid:role.role.roleid,
            }
            // params = this.$qs.stringify(params,{ indices: false });
            this.axios({
                  method:'post',
                  url:window.API_HOST+'/role/deleteRoleById',
                  params:params
            }).then((res)=>{
                console.log(res.data);
                if(res.data.status == '200'){
                    this.$message({
                      message: res.data.data,
                      type: 'success'
                  });
                }
                this.getAllRoleList();
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //获取表格序号
      getIndex($index) {
        //表格序号
        return (this.page.pageNum - 1) * this.page.pageSize + $index + 1
      },
      handleSizeChange(val) {
        this.page.pageSize = val;
        this.getAllRoleList();
      },
      handleCurrentChange(val) {
        this.page.pageNum = val;
        this.getAllRoleList();
      },
      rowClassBody({ rowIndex}) {
        if (rowIndex%2 != 0) {
            return 'text-align: center;background:#F5F7FF;font-size: 14px;height:60px;line-height:60px;'
          }
          return 'text-align:center;font-size: 14px;height:60px;line-height:60px'
       },


    },
    mounted(){
      this.getAllRoleList();
      this.getAllMenu();
    }
  };
</script>
<style lang="scss" scoped>
.conttantin{
  padding: 20px 0 10px 0;
  width: 95%;
  margin:0 auto;
  form{
    width: 95%;
    margin:0 auto;
  }
}
.conttantin1{
  padding: 20px 0 10px 0;
  width: 99%;
  margin:0 auto;
  form{
    width: 95%;
    margin:0 auto;
    display: flex;
    justify-content: flex-end;
  }
}
.s-gray-color1{
  width: 95% !important;
  margin: 0 auto;
}
.block{
  text-align: center;
  padding: 18px 0;
}
.clearfix:after{
  display:block;
  content:"";
  height:0;
  clear:both;
  overflow:hidden;
  visibility:hidden;
}
.el-table__header thead tr:odd{
  background: red !important;
}
.container{
  // box-shadow: #B7C7FF 0px 0px 20px;
}
.title-content{
  display: flex;
  -webkit-display: flex;
  justify-content: center;
  div{
    width: 36%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border-radius: 5px;
    border: 1px solid grey;
  }
  div:last-child{
    margin-left: 50px;
  }
}
.bottom{
  display: flex;
    justify-content: space-between;
    .butt{
      padding: 12px 50px;
    }
}
</style>
